import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
import { offerBullets } from '../data/content';
export function Offer() {
  return <section id="offer" className="scroll-mt-2 border-y-4 border-gold bg-navy px-3 py-4 sm:px-6" data-id="element-114" data-mp="1mmh72e0sz8hy">
      <div className="mx-auto max-w-xl text-center" data-id="element-115" data-mp="1hph1e47v87rd">
        <p className="inline-block rounded-full bg-gold px-3 py-0.5 font-heading text-[0.66rem] font-black uppercase tracking-[0.2em] text-navy-deep sm:text-xs" data-id="element-116" data-mp="1hqs6q8gylnkl">
          SPECIAL LAUNCH OFFER
        </p>
        <h2 className="mt-1.5 font-display text-[1.25rem] font-bold uppercase leading-tight text-white sm:text-[1.9rem]" data-id="element-117" data-mp="13x14zm9gz7zf">
          🔬 SURGICAL INSTRUMENTS <span className="text-gold" data-id="element-118" data-mp="yx50zn0rvgjv">VISUAL ATLAS™</span>
        </h2>
        <p className="mt-0.5 font-heading text-[0.66rem] font-bold uppercase tracking-wide text-white/80 sm:text-[0.82rem]" data-id="element-119" data-mp="2fbogw95pjkii">
          THE COMPLETE VISUAL STUDY SYSTEM FOR SURGICAL INSTRUMENTS
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[250px] sm:max-w-[320px]" target="checkout" data-id="element-120" data-mp="pkqpof5323ce" />

        <div className="mt-2 rounded-md border-2 border-gold bg-white px-3 py-2.5 text-left" data-id="element-121" data-mp="uisfrk0xf2xd">
          <p className="text-center font-heading text-[0.76rem] font-black uppercase tracking-wide text-navy sm:text-[0.9rem]" data-id="element-122" data-mp="zhvbgdv0nwso">
            Complete 6-in-1 System
          </p>
          <ul className="mt-1.5 grid gap-1 sm:grid-cols-2" data-id="element-123" data-mp="13hnkerobo4yk">
            {offerBullets.map(b => <li key={b} className="flex items-start gap-1.5" data-id="element-124" data-mp="bstxkb3eztg0">
                <CheckCircle2Icon className="mt-[1px] h-3.5 w-3.5 shrink-0 text-clinical" strokeWidth={2.5} aria-hidden="true" data-id="element-125" data-mp="btc0fqkl15ww" />
                <span className="text-[0.76rem] leading-tight sm:text-[0.86rem]" data-id="element-126" data-mp="fskuyxng57ti">{b}</span>
              </li>)}
          </ul>
          <p className="mt-2 text-center font-heading text-[0.8rem] font-black uppercase leading-tight text-navy sm:text-[1.02rem]" data-id="element-127" data-mp="3k9f9o0rcf2nc">
            🔥 GET SURGICAL INSTRUMENTS VISUAL ATLAS™ TODAY —{' '}
            <span className="whitespace-nowrap rounded bg-navy px-1.5 text-gold" data-id="element-128" data-mp="veyzwmtrt6zt">$27 USD</span>
          </p>
          <div className="mt-2" data-id="element-129" data-mp="qfmgyd60sk2i">
            <CTAButton label="⚡ GET INSTANT ACCESS" sub="Immediate Digital Access" target="checkout" data-id="element-130" data-mp="qejpa30vidlj" />
          </div>
          <p className="mt-2 text-center font-heading text-[0.64rem] font-bold uppercase tracking-wide text-navy sm:text-xs" data-id="element-131" data-mp="106h1nd3mbblu">
            🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}